import { useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { SharedModalContent } from 'views/components/SharedModal'
import { SamplePartsFullScreen } from 'views/pages/Samples/SampleDetail/LeftBlock/SamplePartsFullScreen'
import { SamplePartsTab, SampleWithRequests } from 'views/pages/Samples/types'

export const FullScreenContent = styled(SharedModalContent)`
  max-height: calc(100dvh - 200px);
`

type Props = {
  sampleShort: SampleWithRequests
}

export const SamplePartsForAccordion: FC<Props> = ({ sampleShort }) => {
  const { t } = useTranslation('samples')
  const [readyToFetch, setReadyToFetch] = useState(false)
  const [partsProgress, partsTable] = useSingleEntity<SamplePartsTab[]>(
    readyToFetch ? endpoints.samplePartsAsJson(sampleShort.id.toString()) : undefined,
  )
  const [fullScreen, setFullScreen] = useState(false)
  useEffect(() => {
    if (!partsTable) return
    setFullScreen(true)
  }, [partsTable])
  return (
    <>
      {fullScreen && partsTable && (
        <SamplePartsFullScreen sampleId={sampleShort.id} data={partsTable} onClose={() => setFullScreen(false)} />
      )}
      <AButton
        id="showSampleParts"
        progress={partsProgress}
        color="secondary"
        onClick={() => (readyToFetch ? setFullScreen(true) : setReadyToFetch(true))}
      >
        {t('analysisResults')}
      </AButton>
    </>
  )
}
